export type QrScannerOverlayStatusTone =
  | "idle"
  | "loading"
  | "success"
  | "error";

export interface QrScannerOverlayStatus {
  text: string;
  tone: QrScannerOverlayStatusTone;
}

export function resolveQrScannerOverlayStatus(args: {
  isResolving: boolean;
  error?: string;
  selectedPayload?: string;
  selectedLabel: string;
  idleText: string;
}): QrScannerOverlayStatus {
  if (args.isResolving) {
    return { text: "Проверяем QR...", tone: "loading" };
  }

  if (args.error) {
    return { text: args.error, tone: "error" };
  }

  if (args.selectedPayload) {
    return { text: `${args.selectedLabel}: ${args.selectedPayload}`, tone: "success" };
  }

  return { text: args.idleText, tone: "idle" };
}
